import { GeoJSON } from 'ol/format';

export interface StaticFileCountryLabel {
  iso3: string;
  name: string;
  labelRank: number;
}

const toCountryLabel = (staticFileCountryLabel: StaticFileCountryLabel) => ({
  id: staticFileCountryLabel.iso3,
  name: staticFileCountryLabel.name,
  rank: staticFileCountryLabel.labelRank,
});

export const toCountryLabelFeature = (staticFileCountryLabelFeature: GeoJSON.Feature<GeoJSON.Point, StaticFileCountryLabel>) => ({
  ...staticFileCountryLabelFeature,
  properties: toCountryLabel(staticFileCountryLabelFeature.properties),
});
